/*
  foodora eShop – small behaviours for account / contact / password pages.
  Depends on nothing (uses window.FD only for native-dialog helpers if present).

  [data-fd-focus]               focus the element on load (error summaries, success notes)
  select[data-fd-country]       country -> province select (replaces Shopify.CountryProvinceSelector)
  [data-fd-delete-address]      opens #fd-address-delete; confirm POSTs the Shopify delete request
  [data-fd-collapse]            closes the surrounding <details>
*/
(function () {
  'use strict';

  if (window.FDPages) return;
  window.FDPages = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- Focus ---------- */
  function focusFirst() {
    var el = document.querySelector('[data-fd-focus]');
    if (!el) return;
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: false });
  }

  /* ---------- Country / province ---------- */
  function readProvinces(option) {
    // data-provinces is server-rendered JSON, but never trust it to parse.
    try {
      var list = JSON.parse(option.getAttribute('data-provinces') || '[]');
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  }

  function selectByValue(select, value) {
    if (!value) return;
    for (var i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      if (o.value === value || o.textContent === value) {
        select.selectedIndex = i;
        return;
      }
    }
  }

  function initCountry(country) {
    var province = document.querySelector(country.getAttribute('data-province-select') || '');
    var field = document.querySelector(country.getAttribute('data-province-field') || '');
    if (!province || !field) return;

    function update(keepDefault) {
      var option = country.options[country.selectedIndex];
      var provinces = option ? readProvinces(option) : [];
      while (province.firstChild) province.removeChild(province.firstChild);
      if (!provinces.length) {
        field.hidden = true;
        province.disabled = true;
        province.required = false;
        return;
      }
      provinces.forEach(function (entry) {
        var opt = document.createElement('option');
        opt.value = String(entry[0]);
        opt.textContent = String(entry[1]);
        province.appendChild(opt);
      });
      province.disabled = false;
      field.hidden = false;
      if (keepDefault) selectByValue(province, province.getAttribute('data-default'));
    }

    selectByValue(country, country.getAttribute('data-default'));
    update(true);
    country.addEventListener('change', function () { update(false); });
  }

  /* ---------- Address delete ---------- */
  function postDelete(url) {
    // Only same-origin paths; Shopify's delete endpoint expects POST + _method=delete.
    if (typeof url !== 'string' || url.charAt(0) !== '/' || url.charAt(1) === '/') return;
    var form = document.createElement('form');
    form.method = 'post';
    form.action = url;
    function hidden(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }
    hidden('_method', 'delete');
    var token = document.querySelector('input[name="authenticity_token"]');
    if (token) hidden('authenticity_token', token.value);
    document.body.appendChild(form);
    form.submit();
  }

  function onClick(event) {
    var del = event.target.closest('[data-fd-delete-address]');
    if (del) {
      var dialog = document.getElementById('fd-address-delete');
      var url = del.getAttribute('data-target');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.setAttribute('data-target', url || '');
        dialog.showModal();
      } else if (window.confirm(del.getAttribute('data-confirm') || '')) {
        postDelete(url);
      }
      return;
    }
    var ok = event.target.closest('[data-fd-delete-confirm]');
    if (ok) {
      var dlg = ok.closest('dialog');
      var target = dlg && dlg.getAttribute('data-target');
      if (dlg) dlg.close();
      postDelete(target);
      return;
    }
    var collapse = event.target.closest('[data-fd-collapse]');
    if (collapse) {
      var details = collapse.closest('details');
      if (details) {
        details.open = false;
        var summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
    }
  }

  ready(function () {
    focusFirst();
    Array.prototype.forEach.call(document.querySelectorAll('select[data-fd-country]'), initCountry);
    document.addEventListener('click', onClick);
  });
})();
